<app-modal
  [isActive]="open"
  (modalState)="closeSyncForm.emit(false)"
  [isSmall]="true"
  [showCloseFooter]="false"
  [enableFooter]="true"
>
  <p class="modal-card-title" modal-title>
    {{ 'involuntary-change.sync.title' | translate }}
  </p>
  <section class="is-size-6" modal-content>
    <div *ngIf="!isReIssueFlow" class="mb-3">
      <p class="mb-1 text has-text-grey">{{ 'involuntary-change.sync.subtitle' | translate }}</p>
      <div *ngFor="let item of OPTIONS" class="mb-1">
        <app-checkradio
          [id]="item.code"
          label="{{ 'involuntary-change.sync.' + item.name | translate }}"
          [checked]="isSynchronized === item.code"
          (click)="isSynchronized = item.code"
        ></app-checkradio>
      </div>
    </div>
    <div *ngIf="isReIssueFlow" class="mb-3">
      <p class="mb-1 text has-text-grey">
        {{ 'involuntary-change.sync.subtitle-reissueFlow' | translate }}
      </p>
      <div *ngFor="let item of OPTIONS_REISSUE_FLOW" class="mb-1">
        <app-checkradio
          [id]="item.code"
          label="{{ 'involuntary-change.sync.' + item.name | translate }}"
          [checked]="isSynchronized === item.code"
          (click)="isSynchronized = item.code"
        ></app-checkradio>
      </div>
    </div>
    <div class="mb-2 w-75">
      <p class="mb-1 weight-medium is-size-9">
        <span *ngIf="isSynchronized === 0">
          {{ isAirline ? (('involuntary-change.sync.no-cost2') | translate) : (('involuntary-change.sync.no-cost') | translate)}}</span>
        <span *ngIf="isSynchronized === 1">
          {{ isAirline ? (('involuntary-change.sync.segment-change2') | translate) : (('involuntary-change.sync.segment-change') | translate)}}</span>
      </p>
      <app-input-field
        *ngIf="aditionalFieldsConfig?.waiverEnabled"
        [form]="form"
        type="text"
        inputName="waiver"
        label="{{ 'exception-mode.waiver-label' | translate }}"
        placeholder="{{ 'exception-mode.waiver-placeholder' | translate }}"
        errorMessage="{{ 'exception-mode.waiver-error-message' | translate }}"
      ></app-input-field>
    </div>

    <div class="mb-2 w-75">
      <app-input-field
        *ngIf="aditionalFieldsConfig?.tourcodeEnabled"
        [form]="form"
        [error]="validateTourcode()"
        type="text"
        inputName="tourCode"
        label="{{ 'exception-mode.tour-code-label' | translate }}"
        placeholder="{{ 'exception-mode.tour-code-placeholder' | translate }}"
      ></app-input-field>
    </div>

    <div class="mb-2">
      <app-osi
        *ngIf="aditionalFieldsConfig?.osiEnabled"
        [formGroup]="form"
        [formArray]="osis()"
        (add)="addOsi($event)"
        (delete)="deleteOsi($event)"
      >
      </app-osi>
    </div>

    <app-alert type="warning">
      <span description>
        {{ 'involuntary-change.sync.accept-all-repro' | translate }}
      </span>
    </app-alert>
  </section>
  <section modal-footer>
    <app-input-submit
      inputText="{{ 'shared.continue' | translate }}"
      type="submit"
      [disabled]="isSynchronized === null || !form.valid"
      (clickButton)="confirmRescheduledItinerary()"
    ></app-input-submit>
  </section>
</app-modal>
